'use client'

import { Hexagon } from 'lucide-react'
import { Reveal } from '../hooks/useReveal'

const navLinks = [
  { label: 'Projects', superscript: '6' },
  { label: 'About', superscript: null },
  { label: 'Blog', superscript: null },
  { label: 'Contact', superscript: null },
]

export function Navbar() {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 border-b border-white/15">
      <div className="flex items-center justify-between px-5 sm:px-8 md:px-12 h-16 sm:h-18">
        {/* Logo */}
        <Reveal delay={0}>
          <div className="flex items-center gap-2">
            <Hexagon className="w-5 h-5 sm:w-6 sm:h-6" strokeWidth={1.5} />
            <span className="text-lg sm:text-xl font-medium tracking-tight">novaai</span>
          </div>
        </Reveal>

        {/* Center nav links */}
        <Reveal delay={100} className="hidden md:flex items-center gap-8 lg:gap-10">
          {navLinks.map((link, i) => (
            <Reveal key={link.label} delay={i * 100} className="relative">
              <a
                href="#"
                className="text-sm text-white/85 hover:text-white transition-colors duration-300"
              >
                {link.label}
                {link.superscript && (
                  <sup className="font-mono text-[10px] text-white/60 ml-0.5">
                    {link.superscript}
                  </sup>
                )}
              </a>
            </Reveal>
          ))}
        </Reveal>

        {/* CTA */}
        <Reveal delay={500} className="flex items-center">
          <a
            href="#"
            className="rounded-md border border-white/20 bg-white/15 backdrop-blur-md px-4 py-2 text-xs sm:px-5 sm:text-sm text-white hover:bg-white/25 transition-colors duration-300"
          >
            Get Free Consultation
          </a>
        </Reveal>
      </div>
    </nav>
  )
}